import { Link } from "react-router-dom";

import logoImg from "../../assets/logo-img.svg";

export default function CompanyUnderReview() {
  return (
    <>
      <div className="company-last-step">
        <div className="navigation-back-home">
          <Link to="/">
            <img src={logoImg} alt="logo" />
          </Link>
          <Link to="/">Back To Home</Link>
        </div>
        <div className="company-application-wrapper">
          <div className="dots-animation">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
          <h2>Your Company Application is under review</h2>
          <p>Your company review will be finished after the meeting</p>
        </div>
      </div>
    </>
  );
}
